import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Jetzt Angebot anfordern ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Zurück zur Startseite ")

import PageBreadcrumbs from '@/components/PhotovoltaikPage/PageBreadcrumbs.vue';
import {
  computed, onBeforeMount, onBeforeUnmount, ref, watch,
} from 'vue';
import { useStore } from 'vuex';
import PageHero from '@/components/PhotovoltaikPage/PageHero.vue';
import PhotovoltaikPageContent from '@/components/PhotovoltaikPage/PhotovoltaikPageContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotovoltaikPage',
  setup(__props) {

const store = useStore();
const pageHeader = ref();
const pageBody = ref();
const pageMainContainer = ref();

const showForm = computed(() => store.state.leadForm.isActive);
const entryForm = () => store.dispatch('leadForm/entry');
const formState = computed(() => store.getters['leadForm/state']);
const isSuccessPage = computed(() => formState.value === 'succeeded' && !showForm.value);

const page = computed(() => {
  if (isSuccessPage.value) {
    return {
      headline: 'Vielen Dank für Ihr Interesse!',
      content: 'Wir prüfen Ihre Angaben und senden Ihnen in Kürze Ihr individuelles Angebot per E-Mail zu.',
      buttonLabel: 'ZURÜCK ZUR STARTSEITE',
    };
  }
  return {
    headline: 'Photovoltaik',
    content: 'Konfigurieren Sie sich Ihre eigene Solaranlage und erhalten Sie ein individuelles Angebot. Schnell, unkompliziert und kostenlos.',
    buttonLabel: 'JETZT ANGEBOT ANFORDERN',
  };
});

const removeCustomStyles = () => {
  if (pageBody.value) {
    pageBody.value.style.removeProperty('padding-top');
  }

  if (pageHeader.value) {
    pageHeader.value.style.removeProperty('background-color');
  }

  if (pageMainContainer.value) {
    pageMainContainer.value.style.removeProperty('padding-top');
  }
};

const runStylePolyfills = () => {
  if (pageBody.value) {
    if (showForm.value) {
      pageBody.value.classList.add('no-hero');
      pageBody.value.classList.remove('has-hero');

      if (pageHeader.value) {
        pageHeader.value.style.setProperty('background-color', '#FFFFFF');

        if (pageMainContainer.value) {
          const { offsetHeight } = pageHeader.value;

          pageMainContainer.value.style.setProperty('padding-top', `${offsetHeight}px`);
        }
      }
    } else {
      pageBody.value.classList.remove('no-hero');
      pageBody.value.classList.add('has-hero');

      if (pageHeader.value) {
        pageHeader.value.style.removeProperty('background-color');

        if (pageMainContainer.value) {
          pageMainContainer.value.style.removeProperty('padding-top');
        }
      }
    }
  }
};

const goBackToHome = () => {
  window.location.pathname = '/';
};

onBeforeMount(() => {
  pageHeader.value = document.querySelector('header');
  pageBody.value = document.querySelector('body');
  pageMainContainer.value = document.querySelector('main.page-body');

  if (pageHeader.value && pageBody.value) {
    window.addEventListener('resize', runStylePolyfills);
  }

  runStylePolyfills();
});

onBeforeUnmount(() => {
  if (pageHeader.value && pageBody.value) {
    window.removeEventListener('resize', runStylePolyfills);
    removeCustomStyles();
  }
});

watch(() => showForm.value, () => {
  runStylePolyfills();
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SolarLeadForm = _resolveComponent("SolarLeadForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(showForm))
      ? (_openBlock(), _createBlock(PageHero, {
          key: 0,
          headline: _unref(page).headline,
          content: _unref(page).content,
          "button-label": _unref(page).buttonLabel
        }, {
          button: _withCtx(() => [
            (_unref(formState) !== 'succeeded')
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 0,
                  color: "primary",
                  class: "m-0",
                  onClick: _withModifiers(entryForm, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 1,
                  color: "primary",
                  class: "m-0",
                  onClick: _withModifiers(goBackToHome, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ]),
          _: 1
        }, 8, ["headline", "content", "button-label"]))
      : _createCommentVNode("", true),
    (!_unref(showForm) && !_unref(isSuccessPage))
      ? (_openBlock(), _createBlock(PageBreadcrumbs, { key: 1 }))
      : _createCommentVNode("", true),
    (!_unref(showForm) && !_unref(isSuccessPage))
      ? (_openBlock(), _createBlock(PhotovoltaikPageContent, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(showForm))
      ? (_openBlock(), _createBlock(_component_SolarLeadForm, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})